module.exports = __webpack_public_path__ + "img/upload.0097ab57551f8ab67623902f344b155f.0097ab57.png";